module.exports = __webpack_public_path__ + "img/harrogate-town.beca4491.png";